import React from 'react';
import { Link } from 'react-router-dom';
import { AppSettings } from './../../config/app-settings.js';
import { slideToggle } from './../../composables/slideToggle.js';
import VARGLO from '../../comun/globales.js';

class SidebarProfile extends React.Component {

	constructor(props) {
		super(props);
		this.state = {
			profileActive: 0
		};
		this.handleProfileExpand = this.handleProfileExpand.bind(this);
	}

	handleProfileExpand(e) {
		e.preventDefault();
		
		var targetSidebar = document.querySelector('.app-sidebar:not(.app-sidebar-end)');
		var targetMenu = e.target.closest('.menu-profile');
		var targetProfile = document.querySelector('#appSidebarProfileMenu');
		var expandTime = (targetSidebar && targetSidebar.getAttribute('data-disable-slide-animation')) ? 0 : 250;
	
		if (targetProfile) {
			if (targetProfile.style.display === 'block') {
				targetMenu.classList.remove('active');
			} else {
				targetMenu.classList.add('active');
			}
			slideToggle(targetProfile, expandTime);
			targetProfile.classList.toggle('expand');
		}
	}
  
	render() {
		return (
			<AppSettings.Consumer>
				{({appSidebarMinify}) => (
					<div className="menu">
						<div className="menu-profile">
							<Link to="/" onClick={this.handleProfileExpand} className="menu-profile-link">
								<div className="menu-profile-cover with-shadow"></div>
								<div class="menu-profile-image menu-profile-image-icon bg-gray-900 text-gray-600">
									<i class="fa fa-user"></i>
								</div>
								<div className="menu-profile-info">
									<div className="d-flex align-items-center">
										<div className="flex-grow-1">
										{VARGLO.nombreCliente}
										</div>
										<div className="menu-caret ms-auto"></div>
									</div>
									<small>{VARGLO.nombreUsuario}</small>
								</div>
							</Link>
						</div>
						<div id="appSidebarProfileMenu" className="collapse">
							<div className="menu-item pt-5px">
								<Link to="/usuario/perfil" className="menu-link">
									<div className="menu-icon"><i className="fa fa-user-gear"></i></div>
									<div className="menu-text">Perfil</div>
								</Link>
							</div>
							<div className="menu-item">
								<Link to="/info/ayuda" className="menu-link">
									<div className="menu-icon"><i className="fa fa-question-circle"></i></div>
									<div className="menu-text"> Ayuda</div>
								</Link>
							</div>
							<div className="menu-item pb-5px">
								<Link to="/usuario/login" className="menu-link">
									<div className="menu-icon"><i className="fa fa-sign-out-alt"></i></div>
									<div className="menu-text"> SALIR</div>
								</Link>
							</div>
							<div className="menu-divider m-0"></div>
						</div>
					</div>
				)}
			</AppSettings.Consumer>
		)
	}
}

export default SidebarProfile;